<template>
  <div
    v-if="oidcIsAuthenticated"
  >
  <div class="input_container change-name">
    <table style="text-align: center;">
      <tr>
        <th>Current First Name: </th>
        <td class= "content" v-html="First"></td>
      </tr>
    </table>
    <div id='EP'>
    <input v-model="newName" type="text" placeholder="New First Name" maxlength="2048"/><br>
    <button v-on:click="executeName">Change First Name</button><br>
    </div>
  </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import CognitoIDSP from 'aws-sdk/clients/cognitoidentityserviceprovider'

var cognito = new CognitoIDSP({
  region: 'eu-west-2'
})

export default {
  name: 'ChangeFirstName',
  data: function () {
    return {
      newName: ''
    }
  },
  computed: {
    ...mapGetters('oidcStore', [
      'oidcIsAuthenticated',
      'oidcAccessToken',
      'oidcUser'
    ]),
    First: function () {
      return this.oidcUser['given_name']
    }
  },
  methods: {
    executeName: function () {
      var changeNameParam = {
        AccessToken: this.oidcAccessToken,
        UserAttributes:
        [
          {
            Name: 'given_name',
            Value: this.newName
          }
        ]
      }
      cognito.updateUserAttributes(changeNameParam, function (err, data) {
        if (err) {
          alert('Your first name could not be changed. Please try again later.')
        } else {
          alert('Your first name has been changed. Please re-login to see the change.')
        }
      })
    }
  }
}
</script>
<style>
</style>
